import React, { Component } from 'react';
import { AuthorizationService } from "../service/AuthorizationService";
import { ProgressSpinner } from 'primereact/progressspinner';
import { ProgressBar } from 'primereact/progressbar';
import { Panel } from 'primereact/panel';
import { Message } from 'primereact/message';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';

export class ClientPasswordReset extends Component {

    constructor() {
        super();
        this.state = {
            loading: true,
            token: '',
            password: '',
            passwordConfirmation: '',
            processFinished: false
        };

        this.authorizationService = new AuthorizationService();
    }

    async componentDidMount() {
        const { client, token } = this.props;
        await this.setState({ loading: false, client, token });
    }

    async setPassword(){
        const { token, password, passwordConfirmation, client } = this.state;
        try {
            if(password !== passwordConfirmation){
                await this.setState({processing: false, processFailed: true, failReason: "Senhas diferentes"});
            }
            else {
                await this.setState({processing: true, processFailed: false});
                const user = await this.authorizationService.setPassword(token, password);
                user.client = client;
                await this.setState({processing: false, processFinished: true});
            }
        } catch (error) {
            console.log(error);
            let failReason = error.toString();
            if(failReason === "invalid token"){
                failReason = "Token inválido"
            }
            await this.setState({processing: false, processFailed: true, failReason});
        }
    }

    render() {        
        const { 
            loading, 
            client, 
            processing,
            processFailed,
            failReason,
            processFinished
         } = this.state;

        if(loading){
            return <div style={{width: '100%', height: '100%', display:'flex', alignItems:'center', justifyContent: 'center'}}>
                <ProgressSpinner strokeWidth="5"/>
            </div>
        }

        if(processFinished){
            return (
                <>
                <div style={{width: '100%', height: '100%', margin: 'auto',display:'flex', alignItems:'center', justifyContent: 'center', backgroundColor: client.custom_layout.secondaryBackgroundColor || ''}}>
                    <Panel style={{width: '400px', margin: 'auto', backgroundColor: client.custom_layout.primaryBackgroundColor || ''}}>
                        <div className="p-grid" style={{backgroundColor: client.custom_layout.primaryBackgroundColor || ''}}>
                                <div className="p-col-12" style={{textAlign: 'center', marginTop:'20px'}}><img alt="Logo" src={client.logo} style={{maxWidth: '300px'}} /></div>
                                <div className="p-col-12" style={{textAlign: 'center', color: client.custom_layout.primaryFontColor || ''}}><b>Senha criada com sucesso</b></div>
                                <div className="p-col-12" style={{textAlign: 'center'}}>
                                    <Button 
                                        disabled={!this.state.passwordConfirmation || !this.state.password || this.state.passwordConfirmation === "" || this.state.password === "" || processing === ""} 
                                        label={"Ir para o Login"}
                                        onClick={() => this.props.onPasswordCreated()}
                                        style={{backgroundColor: client.custom_layout.primaryButtonColor || '', borderColor: client.custom_layout.primaryButtonColor || ''}}
                                    />
                                </div>
                            </div>
                        
                    </Panel>
                </div>
                </>
            );    
        }

        document.title = client.name;
        document.getElementById("favicon").href = client.custom_layout.favicon || "";
        
        return (
            <>
            <div style={{width: '100%', height: '100%', margin: 'auto',display:'flex', alignItems:'center', justifyContent: 'center', backgroundColor: client.custom_layout.secondaryBackgroundColor || ''}}>
                <Panel style={{width: '400px', margin: 'auto', backgroundColor: client.custom_layout.primaryBackgroundColor || ''}}>
                    <div className="p-grid" style={{backgroundColor: client.custom_layout.primaryBackgroundColor || ''}}>
                            <div className="p-col-12" style={{textAlign: 'center', marginTop:'20px'}}><img alt="Logo" src={client.logo} style={{maxWidth: '300px'}} /></div>
                            <div className="p-col-12" style={{color: client.custom_layout.primaryFontColor || ''}}><b>Nova senha</b></div>
                            <div className="p-col-12"><Password disabled={processing} feedback={false} value={this.state.password || ""} onChange={(e) => this.setState({password: e.target.value})} style={{width: '100%'}}/></div>
                            <div className="p-col-12" style={{color: client.custom_layout.primaryFontColor || ''}}><b>Confirme sua nova senha</b></div>
                            <div className="p-col-12"><Password disabled={processing} feedback={false} value={this.state.passwordConfirmation || ""} onChange={(e) => this.setState({passwordConfirmation: e.target.value})} style={{width: '100%'}}/></div>
                            <div className="p-col-12" style={{textAlign: 'center'}}>
                                <Button 
                                    disabled={!this.state.passwordConfirmation || !this.state.password || this.state.passwordConfirmation === "" || this.state.password === "" || processing === ""} 
                                    label={"Criar Senha"}
                                    onClick={() => this.setPassword()}
                                    style={{backgroundColor: client.custom_layout.primaryButtonColor || '', borderColor: client.custom_layout.primaryButtonColor || ''}}
                                />
                                { processing && <div style={{marginTop: '10px'}}><ProgressBar mode="indeterminate"/></div> }
                                { processFailed && <Message severity="error" text={failReason} closable={false} style={{marginLeft: '10px'}}/>}
                            </div>
                        </div>
                    
                </Panel>
            </div>
            </>
        );
    }
}